<template><div><h1 id="aufgabenbearbeitung" tabindex="-1"><a class="header-anchor" href="#aufgabenbearbeitung"><span>Aufgabenbearbeitung</span></a></h1>
<p>Aufgabenbearbeitung — Manuelle Bearbeitung der offenen Aufgaben</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden alle <RouteLink to="/referenz/refs/ft.refdata.aufgaben.html" title="Einstellungen zu Aufgaben">Aufgaben</RouteLink> aufgelistet. Zu jeder Aufgabe wird die entsprechende <RouteLink to="/referenz/refs/ft.refdata.ftml.html" title="FTML-Datenbearbeitung">FTML-Transaktion</RouteLink> angezeigt. Die Bearbeitung wird in den entsprechenden ft-Modulen vorgenommen.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Aufgabenbearbeitung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Datum</dt>
<dd>Erstelldatum der Aufgabe</dd>
<dt>Transaktion</dt>
<dd>Transaktionsnummer und Detailansicht der zugehörigen <a class="link" href="ft.refdata.ftml.html" title="FTML-Datenbearbeitung">FTML-Transaktion</a>.</dd>
<dt>Adresse</dt>
<dd>Die funtrade-Personen-ID wird dann angezeigt, wenn funtrade bei der Erstellung der Aufgabe eine ft-Adresse zuordnen kann, ansonsten erscheint ein &quot;?&quot;.</dd>
<dt>Adresse Detail</dt>
<dd>Name, Vorname, Ort, zugeordnete ft-Personen-ID aus der <a class="link" href="ft.refdata.ftml.html" title="FTML-Datenbearbeitung">FTML-Transaktion</a></dd>
<dt>Typ</dt>
<dd>Aufgabe gem. <a class="link" href="ft.refdata.aufgaben.html" title="Einstellungen zu Aufgaben">Aufgaben</a>.</dd>
<dt>verarb.</dt>
<dd>Zeigt an, ob die Aufgabe die weitere Verarbeitung sperrt (&quot;nein&quot;= Sperre'gem. <a class="link" href="ft.refdata.aufgaben.html" title="Einstellungen zu Aufgaben">Aufgaben</a>). Bei so gesperten Aufgaben kann eine Fakturierung des betreffenden Auftrages erst erfolgen werden, wenn der Aufgabenstatus auf &quot;bearb.&quot; gesetzt ist (siehe unten)</dd>
<dt>Text</dt>
<dd>Enthält zusätzliche Informationen aus der Transaktion wie z.B. Textelemente bei falscher Schreibweise vo Adressen.</dd>
<dt>Gruppe</dt>
<dd>Bezeichnet die für die Aufgabenbearbeitung verantwortliche Stelle.</dd>
<dt>Status</dt>
<dd>Bearbeitungsstaus dar Aufgabe. Dieser Status kann manuell gesetzt werden.</dd>
</dl>
<div class="hint-container warning">
<p class="hint-container-title">Achtung</p>
<p>Ein gesetzter Status kann nicht wieder rückgängig gemacht werden!</p>
</div>
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>neu</td>
<td>Die Aufgabe ist noch nicht bearbeitet worden</td>
</tr>
<tr>
<td>offen</td>
<td>Die Aufgabe befindet sich in Bearbeitung. Dieser Status kann nur manuell gesetzt werden.</td>
</tr>
<tr>
<td>bearb.</td>
<td>Die Aufgabe ist abgearbeitet. Bei Aufgaben mit verarb.=&quot;nein&quot; wird die Fakturierung erst ausgelöst, wenn dieser STatus gesetzt ist. Dieser Status wird durch die Funktion &quot;Transaktion verarbeiten&quot; oder manuell gesetzt.</td>
</tr>
</tbody>
</table>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="kontext-offnen" tabindex="-1"><a class="header-anchor" href="#kontext-offnen"><span>Kontext öffnen</span></a></h3>
<p>Öffnet ein Fenster für die manuelle Bearbeitung. Welches ft-Modul geöffnet wird, ist abhängig von den Einstellungen in der Tabelle <RouteLink to="/referenz/refs/ft.refdata.aufgaben.html" title="Einstellungen zu Aufgaben">Aufgaben</RouteLink>.</p>
<h3 id="transaktion-verarbeiten" tabindex="-1"><a class="header-anchor" href="#transaktion-verarbeiten"><span>Transaktion verarbeiten</span></a></h3>
<p>Mit dieser Funktion wird die <RouteLink to="/referenz/refs/ft.refdata.ftml.html" title="FTML-Datenbearbeitung">FTML-Transaktion</RouteLink> verarbeitet. Dies ist nur bei Aufgaben mit Status &quot;neu&quot; möglich.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.aufgaben.html" title="Einstellungen zu Aufgaben">Aufgaben</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.ftml.html" title="FTML-Datenbearbeitung">FTML</RouteLink></p>
</div></template>


